export default function SvgUsersEditIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M9.166 12.5h-2.5c-1.553 0-2.33 0-2.942.254a3.334 3.334 0 00-1.804 1.804c-.254.612-.254 1.389-.254 2.942m11.25-14.758a3.334 3.334 0 012.083 3.091m-5 12.084l1.688-.338c.147-.03.22-.044.29-.07a.833.833 0 00.171-.093c.061-.042.114-.095.22-.201l5.548-5.548A1.179 1.179 0 0016.25 10l-5.548 5.548c-.106.106-.159.159-.2.22a.829.829 0 00-.093.172c-.027.069-.042.142-.071.29l-.338 1.687zm1.25-12.084a3.333 3.333 0 11-6.666 0 3.333 3.333 0 016.666 0z"
      ></path>
    </svg>
  )
}
